module.exports = __webpack_public_path__ + "static/media/spotify_podcasts.e359ad39.svg";